<template>
	<div class="kqs-page">
		<!-- 无权限保护：仅财务可见 -->
		<div v-if="!isFinance" class="kqs-forbidden">
			<i class="el-icon-lock"></i>
			<div class="fb-title">无权访问</div>
			<div class="fb-tip">客情统计仅对财务角色开放。</div>
		</div>

		<template v-else>
			<div class="kqs-toolbar">
				<span class="kqs-title">客情统计</span>
				<!-- 快捷选择 -->
				<el-radio-group v-model="quick" size="small" @change="onQuickChange">
					<el-radio-button label="today">今天</el-radio-button>
					<el-radio-button label="yesterday">昨天</el-radio-button>
					<el-radio-button label="week7">近7天</el-radio-button>
					<el-radio-button label="day30">近30天</el-radio-button>
					<el-radio-button label="thisMonth">本月</el-radio-button>
					<el-radio-button label="lastMonth">上月</el-radio-button>
				</el-radio-group>
				<el-date-picker v-model="range" type="daterange" size="small" unlink-panels
					value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" class="kqs-range" :clearable="false"
					@change="onRangeChange"></el-date-picker>
				<el-select v-model="salespersonId" size="small" clearable placeholder="全部业务员"
					class="kqs-sales" @change="onQuery">
					<el-option v-for="sp in salesOptions" :key="sp.id"
						:label="sp.nickName || sp.userName" :value="sp.id"></el-option>
				</el-select>
				<el-button type="primary" size="small" icon="el-icon-download" :loading="exporting"
					:disabled="!buckets.length && !reportsTotal" @click="exportAll">综合导出</el-button>
			</div>

			<!-- 汇总卡片 -->
			<div class="kqs-cards">
				<div class="kqs-card">
					<div class="kc-label">填报总数</div>
					<div class="kc-value">{{ stats.totalReports || 0 }}</div>
				</div>
				<div class="kqs-card">
					<div class="kc-label">参与业务员</div>
					<div class="kc-value">{{ stats.totalSalespersons || 0 }}</div>
				</div>
				<div class="kqs-card" v-for="f in numericFields" :key="f.id">
					<div class="kc-label">{{ f.name }}(合计)</div>
					<div class="kc-value">{{ formatNum(stats.totalSums && stats.totalSums[f.id]) }}</div>
				</div>
			</div>

			<!-- 按人汇总(总表) -->
			<div class="kqs-section">
				<div class="ks-title">按人汇总（总表）</div>
				<el-table :data="salesRows" size="small" empty-text="暂无客情数据" v-loading="statsLoading"
					max-height="320">
					<el-table-column prop="salespersonName" label="姓名" width="110"></el-table-column>
					<el-table-column prop="totalFans" label="总粉" width="90">
						<template slot-scope="scope">{{ formatNum(scope.row.totalFans) }}</template>
					</el-table-column>
					<el-table-column v-for="f in fields" :key="f.id" :label="f.name" min-width="80">
						<template slot-scope="scope">{{ sumVal(scope.row, f.id) }}</template>
					</el-table-column>
					<el-table-column prop="reportCount" label="填报次数" width="90"></el-table-column>
				</el-table>
			</div>

			<!-- 按天汇总 -->
			<div class="kqs-section">
				<div class="ks-title">按天汇总</div>
				<el-table :data="buckets" size="small" empty-text="暂无客情数据" v-loading="statsLoading"
					max-height="320">
					<el-table-column prop="bucket" label="日期" width="110"></el-table-column>
					<el-table-column prop="reportCount" label="填报数" width="80"></el-table-column>
					<el-table-column prop="salespersonCount" label="填报人数" width="90"></el-table-column>
					<el-table-column v-for="f in fields" :key="f.id" :label="f.name" min-width="90">
						<template slot-scope="scope">{{ sumVal(scope.row, f.id) }}</template>
					</el-table-column>
				</el-table>
			</div>

			<!-- 填报明细 -->
			<div class="kqs-section">
				<div class="ks-title">填报明细</div>
				<el-table :data="reports" size="small" empty-text="暂无填报明细" v-loading="reportsLoading"
					max-height="420">
					<el-table-column prop="reportDate" label="日期" width="110"></el-table-column>
					<el-table-column prop="salespersonName" label="业务员" width="120"></el-table-column>
					<el-table-column prop="kqGroupName" label="客勤群" width="140" show-overflow-tooltip></el-table-column>
					<el-table-column v-for="f in fields" :key="f.id" :label="f.name" min-width="90">
						<template slot-scope="scope">{{ contentVal(scope.row, f.id) }}</template>
					</el-table-column>
				</el-table>
				<el-pagination v-if="reportsTotal > reportsPageSize" class="kqs-page-bar" background
					layout="prev, pager, next, total" :total="reportsTotal" :page-size="reportsPageSize"
					:current-page="reportsPageNo" @current-change="loadReports"></el-pagination>
			</div>
		</template>
	</div>
</template>

<script>
import bizApi from '../api/bizApi.js';

export default {
	name: 'kqStats',
	data() {
		return {
			quick: 'day30',
			range: [],
			salespersonId: null,
			salesOptions: [],
			// 汇总
			stats: {},
			fields: [],
			buckets: [],
			salesRows: [],
			statsLoading: false,
			// 明细
			reports: [],
			reportsTotal: 0,
			reportsPageNo: 1,
			reportsPageSize: 20,
			reportsLoading: false,
			exporting: false
		};
	},
	computed: {
		isFinance() {
			return this.userStore && this.userStore.isBizFinance;
		},
		// 有数值合计的字段(总量卡片只展示这些)
		numericFields() {
			const sums = this.stats.totalSums || {};
			return this.fields.filter(f => sums[f.id] !== undefined && sums[f.id] !== null);
		}
	},
	methods: {
		async initPage() {
			if (this.isFinance) {
				this.init();
			} else {
				try {
					await this.userStore.loadBizRole();
				} catch (e) {
					console.error('[KqStats] retry loadBizRole failed', e);
				}
				if (this.isFinance) {
					this.init();
				}
			}
		},
		fmt(d) {
			return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
		},
		// 快捷选择 → 日期范围
		quickRange(key) {
			const now = new Date();
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
			switch (key) {
				case 'today':
					return [this.fmt(today), this.fmt(today)];
				case 'yesterday': {
					const y = new Date(today.getTime() - 86400000);
					return [this.fmt(y), this.fmt(y)];
				}
				case 'week7':
					return [this.fmt(new Date(today.getTime() - 6 * 86400000)), this.fmt(today)];
				case 'day30':
					return [this.fmt(new Date(today.getTime() - 29 * 86400000)), this.fmt(today)];
				case 'thisMonth':
					return [this.fmt(new Date(today.getFullYear(), today.getMonth(), 1)), this.fmt(today)];
				case 'lastMonth': {
					const first = new Date(today.getFullYear(), today.getMonth() - 1, 1);
					const last = new Date(today.getFullYear(), today.getMonth(), 0);
					return [this.fmt(first), this.fmt(last)];
				}
				default:
					return [this.fmt(new Date(today.getTime() - 29 * 86400000)), this.fmt(today)];
			}
		},
		onQuickChange(key) {
			this.range = this.quickRange(key);
			this.onQuery();
		},
		onRangeChange() {
			// 手动改日期后取消快捷高亮
			this.quick = '';
			this.onQuery();
		},
		params() {
			const p = {};
			if (this.range && this.range.length === 2) {
				p.from = this.range[0];
				p.to = this.range[1];
			}
			if (this.salespersonId) p.salespersonId = this.salespersonId;
			return p;
		},
		onQuery() {
			this.loadStats();
			this.loadReports(1);
		},
		loadStats() {
			this.statsLoading = true;
			const p = Object.assign({ period: 'day' }, this.params());
			bizApi.kqStats(p).then((d) => {
				this.stats = d || {};
				this.fields = (d && d.fields) || [];
				this.buckets = (d && d.buckets) || [];
				this.salesRows = (d && d.salesRows) || [];
			}).catch(() => { }).finally(() => { this.statsLoading = false; });
		},
		loadReports(page) {
			this.reportsPageNo = page || 1;
			this.reportsLoading = true;
			const p = Object.assign({ pageNo: this.reportsPageNo, pageSize: this.reportsPageSize }, this.params());
			bizApi.kqReports(p).then((d) => {
				this.reports = (d && d.list) || [];
				this.reportsTotal = (d && Number(d.total)) || 0;
			}).catch(() => { }).finally(() => { this.reportsLoading = false; });
		},
		// 静默刷新(不开loading遮罩):业务员改完客情数据后,管理员/财务开着页面也能自动看到最新
		silentReload() {
			if (document.hidden || !this.isFinance) return;
			const ps = Object.assign({ period: 'day' }, this.params());
			bizApi.kqStats(ps).then((d) => {
				this.stats = d || {};
				this.fields = (d && d.fields) || [];
				this.buckets = (d && d.buckets) || [];
				this.salesRows = (d && d.salesRows) || [];
			}).catch(() => { });
			const pr = Object.assign({ pageNo: this.reportsPageNo, pageSize: this.reportsPageSize }, this.params());
			bizApi.kqReports(pr).then((d) => {
				this.reports = (d && d.list) || [];
				this.reportsTotal = (d && Number(d.total)) || 0;
			}).catch(() => { });
		},
		formatNum(v) {
			// 0、空均展示为 -
			return v === undefined || v === null || Number(v) === 0 ? '-' : v;
		},
		sumVal(row, fieldId) {
			const v = (row.sums || {})[fieldId];
			return v === undefined || v === null || Number(v) === 0 ? '-' : v;
		},
		contentVal(row, fieldId) {
			if (!row._contentMap) {
				let map = {};
				try {
					map = JSON.parse(row.content) || {};
				} catch (e) { /* ignore */ }
				row._contentMap = map;
			}
			const v = row._contentMap[String(fieldId)];
			// 未填写与填0均展示为 -
			return v === undefined || v === null || v === '' || String(v).trim() === '0' ? '-' : v;
		},
		htmlEscape(val) {
			return String(val == null ? '' : val)
				.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		},
		// Excel表(HTML格式.xls,支持黄色表头等样式)
		xlsTable(headers, rows) {
			let h = '<table border="1" cellspacing="0" cellpadding="4">';
			h += '<tr>' + headers.map(x => '<th style="background:#FFFF00;font-weight:bold;text-align:center;">' + this.htmlEscape(x) + '</th>').join('') + '</tr>';
			rows.forEach(r => {
				h += '<tr>' + r.map(x => '<td style="text-align:center;">' + this.htmlEscape(x) + '</td>').join('') + '</tr>';
			});
			return h + '</table>';
		},
		// 综合导出：汇总 + 按人 + 明细 合并为一个带黄色表头的Excel(.xls)
		async exportAll() {
			if (this.exporting) return;
			this.exporting = true;
			try {
				const rangeTag = (this.range && this.range.length === 2)
					? this.range[0] + '至' + this.range[1] : '全部';
				const parts = [];
				parts.push('<h3>' + this.htmlEscape('客情统计综合导出（' + rangeTag + '）') + '</h3>');
				// 段一：按天汇总
				parts.push('<p><b>【按天汇总】</b></p>');
				const sRows = this.buckets.map(b => [b.bucket, b.reportCount || 0, b.salespersonCount || 0]
					.concat(this.fields.map(f => this.sumVal(b, f.id))));
				sRows.push(['合计', this.stats.totalReports || 0, this.stats.totalSalespersons || 0]
					.concat(this.fields.map(f => {
						const v = (this.stats.totalSums || {})[f.id];
						return v === undefined || v === null || Number(v) === 0 ? '-' : v;
					})));
				parts.push(this.xlsTable(['日期', '填报数', '填报人数'].concat(this.fields.map(f => f.name)), sRows));
				// 段二：按人汇总(总表)
				parts.push('<p><b>【按人汇总（总表）】</b></p>');
				const pRows = this.salesRows.map(r => [r.salespersonName || '', this.formatNum(r.totalFans)]
					.concat(this.fields.map(f => this.sumVal(r, f.id)))
					.concat([r.reportCount || 0]));
				parts.push(this.xlsTable(['姓名', '总粉'].concat(this.fields.map(f => f.name)).concat(['填报次数']), pRows));
				// 段三：填报明细(全量拉取，后端单页上限500)
				const d = await bizApi.kqReports(Object.assign({ pageNo: 1, pageSize: 500 }, this.params()));
				const list = (d && d.list) || [];
				parts.push('<p><b>【填报明细】</b></p>');
				const dRows = list.map(r => [r.reportDate || '', r.salespersonName || '', r.kqGroupName || '']
					.concat(this.fields.map(f => this.contentVal(r, f.id))));
				parts.push(this.xlsTable(['日期', '业务员', '客勤群'].concat(this.fields.map(f => f.name)), dRows));
				const html = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">'
					+ '<head><meta charset="utf-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>'
					+ '<x:Name>客情统计</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>'
					+ '</x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>'
					+ parts.join('') + '</body></html>';
				const blob = new Blob(['\ufeff' + html], { type: 'application/vnd.ms-excel;charset=utf-8;' });
				const url = URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = `客情统计综合_${rangeTag}.xls`;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				URL.revokeObjectURL(url);
			} catch (e) {
				// http 拦截器已弹出错误提示
			} finally {
				this.exporting = false;
			}
		},
		init() {
			this.range = this.quickRange(this.quick);
			bizApi.salespersons().then((list) => {
				this.salesOptions = list || [];
			}).catch(() => { });
			this.onQuery();
		}
	},
	watch: {
		// bizRole 由异步 me() 写入，可能晚于 mounted，就位后补加载
		isFinance(val) {
			if (val && !this.buckets.length) {
				this.init();
			}
		}
	},
	mounted() {
		this.initPage();
		// 每30秒静默刷新一次,保证业务员修改客情后管理员端实时可见
		this._kqsTimer = setInterval(this.silentReload, 30000);
	},
	beforeDestroy() {
		if (this._kqsTimer) {
			clearInterval(this._kqsTimer);
			this._kqsTimer = null;
		}
	}
};
</script>

<style scoped lang="scss">
.kqs-page {
	height: 100%;
	overflow-y: auto;
	padding: 20px 28px;
	box-sizing: border-box;
	text-align: left;
	color: #333;

	.kqs-forbidden {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		color: #909399;

		i {
			font-size: 46px;
		}

		.fb-title {
			margin-top: 14px;
			font-size: 18px;
			font-weight: 600;
		}

		.fb-tip {
			margin-top: 8px;
			font-size: 13px;
		}
	}

	.kqs-toolbar {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 12px;
		margin-bottom: 18px;

		.kqs-title {
			font-size: 18px;
			font-weight: 600;
			margin-right: 4px;
		}

		.kqs-range {
			width: 260px;
		}

		.kqs-sales {
			width: 140px;
		}
	}

	.kqs-cards {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		margin-bottom: 18px;

		.kqs-card {
			min-width: 120px;
			padding: 12px 18px;
			background: #f5f7fa;
			border-radius: 8px;

			.kc-label {
				font-size: 12px;
				color: #909399;
			}

			.kc-value {
				margin-top: 6px;
				font-size: 22px;
				font-weight: 600;
				color: #303133;
			}
		}
	}

	.kqs-section {
		margin-bottom: 24px;

		.ks-title {
			font-size: 15px;
			font-weight: 600;
			margin-bottom: 10px;
		}
	}

	.kqs-page-bar {
		margin-top: 12px;
		text-align: right;
	}
}
</style>
